import { Link } from 'react-router-dom';
import { FileText, ChevronLeft } from 'lucide-react';

export const TermsConditions = () => {
  return (
    <div className="subpage-container" data-testid="terms-conditions-page">
      <section className="subpage-hero policy-hero">
        <div className="subpage-hero-inner">
          <div className="policy-top-nav">
            <Link to="/" className="policy-back-link">
              <ChevronLeft size={16} /> Back to Home
            </Link>
          </div>

          <div className="policy-header-content">
            <div className="policy-hero-badge">
              <FileText size={15} /> LEGAL AGREEMENT &amp; POLICIES
            </div>
            <h1 className="subpage-title">Terms &amp; Conditions</h1>
            <p className="policy-effective-date">
              Effective Date: September 9, 2026 · Giraffe Entertainment &amp; Experiences (Giraffe Group)
            </p>
          </div>
        </div>
      </section>

      <div className="subpage-body site-container policy-body">
        <div className="policy-content-card">
          <section className="policy-section">
            <h2>01. Acceptance of Terms</h2>
            <p>
              Welcome to <strong>Giraffe Entertainment &amp; Experiences ("GEE", "we", "our", or "us")</strong>, an experiential entertainment division operating under the Giraffe Group. By accessing or using our website (<strong>gee.rocks</strong>), purchasing experience tickets, or visiting any of our physical attractions (including our flagship 7D Cinema at Guptar Ghat, Ayodhya), you agree to be bound by these Terms and Conditions.
            </p>
            <p>
              If you do not agree with any part of these terms, you should refrain from using our online platforms or participating in our ticketed experiential attractions.
            </p>
          </section>

          <section className="policy-section">
            <h2>02. Scope of Experiences &amp; Services</h2>
            <p>
              GEE specializes in narrative-driven, multi-sensory entertainment, including:
            </p>
            <ul className="policy-list">
              <li><strong>Immersive 7D Motion Cinema:</strong> High-definition stereoscopic presentations synchronized with active motion platforms and environmental effects.</li>
              <li><strong>Cultural &amp; Sacred Heritage Attractions:</strong> Experiential exhibitions and visual journeys exploring India's revered heritage corridors.</li>
              <li><strong>Turnkey Entertainment Partnerships:</strong> Design, architectural integration, and venue operations developed in collaboration with tourism bodies and private partners.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>03. Ticketing, Admission &amp; Health Guidelines</h2>
            <p>
              To ensure guest comfort, safety, and immersion across all physical venues:
            </p>
            <ul className="policy-list">
              <li><strong>Valid Admission:</strong> Every visitor must hold a valid physical ticket or verified digital booking confirmation to gain entry to the screening auditorium.</li>
              <li><strong>7D Motion Seat Safety:</strong> Our 7D attractions employ rapid pneumatic motion, pitch, heave, and roll. Expectant mothers, individuals with severe cardiovascular conditions, neck or back injuries, or severe vertigo are strongly advised to request stationary seating options before the screening commences.</li>
              <li><strong>Child Supervision:</strong> Children under 12 years of age must be accompanied by a responsible adult guardian at all times within the venue.</li>
              <li><strong>Timely Arrival:</strong> Guests are requested to arrive at the auditorium at least 15 minutes prior to their allocated showtime. Late entries may be deferred to the subsequent screening to avoid disrupting the immersion of seated guests.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>04. Visitor Code of Conduct</h2>
            <p>
              All visitors are expected to maintain respect for fellow guests and venue staff:
            </p>
            <ul className="policy-list">
              <li><strong>No Unauthorized Recording:</strong> Video recording, flash photography, or live streaming during the 7D cinema screening is strictly prohibited to safeguard proprietary intellectual property.</li>
              <li><strong>Prohibited Items:</strong> Outside food, beverages, flammable substances, and sharp objects are strictly disallowed inside the theater.</li>
              <li><strong>Right of Refusal:</strong> Venue supervisors reserve the right to deny admission or escort any person from the premises exhibiting disorderly conduct, intoxication, or non-compliance with safety staff.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>05. Intellectual Property Rights</h2>
            <p>
              All content hosted on this website and showcased within our experiential theaters — including 3D animation reels, cinematic soundscapes, logos, brand marks, architectural renderings, text, and graphics — is the exclusive intellectual property of <strong>Giraffe Group</strong> and protected under Indian and international copyright and trademark laws. Unauthorized reproduction, commercial distribution, or modification is expressly prohibited.
            </p>
          </section>

          <section className="policy-section">
            <h2>06. Limitation of Liability &amp; Force Majeure</h2>
            <p>
              While we take every measure to ensure flawless operations, GEE shall not be liable for:
            </p>
            <ul className="policy-list">
              <li>Personal property loss or damage brought onto venue premises.</li>
              <li>Show cancellations, schedule adjustments, or delays resulting from Force Majeure events, including severe weather disruptions, river flooding, power interruptions, or regulatory orders.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>07. Governing Law &amp; Jurisdiction</h2>
            <p>
              These Terms &amp; Conditions are governed by and construed in accordance with the laws of the Republic of India. Any legal dispute, claim, or proceeding arising out of or related to our services shall be subject to the exclusive jurisdiction of the competent courts located in <strong>New Delhi, India</strong>.
            </p>
          </section>

          <section className="policy-section">
            <h2>08. Contact &amp; Grievance Redressal</h2>
            <p>
              For inquiries, legal notices, or clarification regarding these terms, please contact our corporate desk:
            </p>
            <div className="policy-contact-box">
              <p><strong>Giraffe Corporate House</strong></p>
              <p>House No 292, Asiad Village, Near Sirifort Auditorium, New Delhi – 110049</p>
              <p>Email: <a href="mailto:hello@giraffegroup.in">hello@giraffegroup.in</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
